import React, { useState, useEffect } from "react";
import {
  AdvSeparator,
  Button,
  CopyToClipboard,
  Drawer,
  DualIcon,
  InfoTextAdv,
  NewTab,
  PageHeader,
  PageTab,
  PageTitle,
  SmartTooltip,
  StatusTags,
  Modal,
  DocumentViewer,
  showToast,
  LogoLoader,
  Backdrop,
  DocumentViewerATS
} from "../../../../../components";
import { ENDPOINTS } from "../../../../../redux/apiConfig";
import Resume from "../AllApplicantsViewTabs/Resume";
import PersonalDetails from "../AllApplicantsViewTabs/PersonalDetails";
import JobApplied from "../AllApplicantsViewTabs/JobApplied";
import Notes from "../AllApplicantsViewTabs/Notes";
import Skills from "../AllApplicantsViewTabs/Skills";
import WorkExperience from "../AllApplicantsViewTabs/WorkExperience";
import EmailMerges from "../AllApplicantsViewTabs/EmailMerges";
import ApplicantEmailModal from "./ApplicantDetailsModals/ApplicantEmailModal";
import ApplicantNotesModal from "./ApplicantDetailsModals/ApplicantNotesModal";
import ApplicantSubmitJobModal from "./ApplicantDetailsModals/ApplicantSubmitJobModal";
import { getCandidateResumeFromDB } from "../../../../../redux/slices/internalDbES/internalDbESApi";
import { fetchResumeDataStart } from "../../../../../redux/slices/bdmjobs/bdmjobsSlice";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addCandidateNotes } from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
import axiosRequest from "../../../../../redux/slices/universal/axiosService";

const ResumeViewer = ({ isOpen, onClose }) => {
  // UI state
  const [emailModal, setEmailModal] = useState(false);
  const [notesModal, setNotesModal] = useState(false);
  const [submitJobModal, setSubmitJobModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [awsUrl, setAwsUrl] = useState("");
  const [notes, setCandidateNotes] = useState("");
  const dispatch = useDispatch();
  const resume = localStorage.getItem("resumeId") || "{}";
  const resumeDataSaga = useSelector(
    (state) => state?.bdmJobs?.resumeData || {}
  );
  const { user } = useSelector((state) => state?.auth);
  // Safe read & dispatch localStorage on mount
  useEffect(() => {
    try {
      const raw = localStorage.getItem("applicantData") || "{}";
      if (raw) {
        const parsed = JSON.parse(raw);
        //console.debug("Dispatching parsed applicantData:", parsed);
        if (!resumeDataSaga?.data?.candidate) {
          dispatch(fetchResumeDataStart(parsed));
        }
      } else {
        console.warn("No applicantData found in localStorage");
      }
    } catch (err) {
      console.error("Failed to parse or dispatch applicantData:", err);
    }
  }, [dispatch]);

  // Select resume payload from store (support either flat or nested shapes)

  //const sData = resumeDataSaga?.data || resumeDataSaga || {}; 
  const sData = (() => {
    const data = resumeDataSaga?.data || [];
    // If it's an array of resumes, find the matching one
    if (Array.isArray(data)) {
      return data.find((item) => item?.candidate?.resumeIds?.[0] === resumeId) || {};
    }
    // If it's a single object, just return it
    return data;
  })();
  //console.log(sData)//resumeId

  if (sData?.candidate) {
    localStorage.removeItem("applicantData");
  }

  const contactHeader =
    (typeof sData?.getCurrentApplicantContactDetailsForHeader === "function"
      ? sData?.getCurrentApplicantContactDetailsForHeader()
      : sData?.currentApplicantContactDetailsForHeader) || {};
  // console.log(contactHeader)
  // console.log(sData?.candidate)
  const FixedContactHeader = {
    "Mobile": contactHeader?.["Mobile"] || "—",
    "Job Title": contactHeader?.["Job Title"] || "—",
    "Location": contactHeader?.["Location"] || "—",
    "Work Authorization": contactHeader?.["Work Authorizationn"] || contactHeader?.["Work Authorization"] || "—",
    "Experience (Years)": contactHeader?.["Experience(Years)"] || "—",
    "Email": sData?.candidate?.email?.primary?.email || sData?.candidate?.email?.primary || contactHeader?.["Email"] || "—",
  }
  const currentApplicantJobTitle =
    (typeof sData?.getCurrentApplicantJobTitle === "function"
      ? sData?.getCurrentApplicantJobTitle()
      : sData?.currentApplicantJobTitle) || "";

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem("resumeId");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      localStorage.removeItem("resumeId"); // also remove on unmount just in case
    };
  }, []);

  //console.log(sData?.candidate)
  // Build view menus using sData (safe)
  const viewMenus = [
    {
      title: "Resume",
      page: (
        <Resume
          candidate={sData?.candidate}
          source={sData?.source}
          searchQuery={sData?.searchQuery}
          keywords={sData?.keywords}
          onClose={sData?.onClose || onClose}
          loading={sData?.loading}
        />
      ),
      type: "main",
    },
    {
      title: "Personal Details",
      page: (
        <PersonalDetails
          applicant={
            typeof sData?.currentApplicantPersonalDetails === "function"
              ? sData?.currentApplicantPersonalDetails()
              : sData?.currentApplicantPersonalDetails || {}
          }
          origin={"resumeViewer"}
        />
      ),
      type: "main",
    },
    {
      title: "Job Applied",
      page: <JobApplied />,
      type: "main",
    },
    {
      title: "Notes",
      page: <Notes applicantId={sData?.candidate?.uiid} />,
      type: "main",
    },
    {
      title: "Skills",
      page: <Skills applicant={sData?.candidate} />,
      type: "main",
    },
    {
      title: "Work Experience",
      page: <WorkExperience applicant={sData?.candidate} />,
      type: "main",
    },
    {
      title: "Email Merges",
      page: <EmailMerges />,
      type: "main",
    },
  ];

  const resumeData = sData?.candidate;
  const resumeLink = resumeData?.resumes?.at(-1)?.files?.at(-1)?.key ?? "";
  const resumeName =
    `${resumeData?.firstName} ${resumeData?.lastName}` ?? "resume";
  const resumePathName = resumeData?.resumes?.at(-1)?.files?.at(-1)?.name ?? "Resume";
  const resumeId = resumeData?.resumeIds?.[0] ?? "";

  // console.log(resumeData)

  function extractS3Key(url) {
        return url.replace(/^https?:\/\/[^/]+\//, '');
    }

  const getCandidateResume = async () => {
    const query = new URLSearchParams({
      key: extractS3Key(resumeLink),
      fileName: resumePathName,
      coll: "Candidate",
    }).toString();

    const url = `${ENDPOINTS.CANDIDATES.RESUME_URL}?${query}`;

    try {
       const response= await axiosRequest({method:"GET",url})
      const data = response?.data?.data?.url || "";
       if(!response?.success){
        showToast("Download unsuccessful.", "error");
       }
      handleDownloadResume(data);
    } catch (err) {
      console.error("Error fetching data:", err);
      showToast("Download unsuccessful.", "error");
    }
  };

  const viewResume = async () => {
    const query = new URLSearchParams({
      key: extractS3Key(resumeLink),
      fileName: resumePathName,
      coll: "Candidate",
    }).toString();

    const url = `${ENDPOINTS.CANDIDATES.RESUME_URL}?${query}`;
    try {
      const response= await axiosRequest({method:"GET",url})
      const s3Key = response?.data?.data?.url || "";
      setAwsUrl(s3Key);
    } catch (err) {
      console.log("err", err);
    }
  };

  const handleDownloadResume = async (response) => {
    try {
      // ---------- REPLACE FROM HERE ----------
      // if response is a URL string, just open it directly for download
      if (typeof response === "string" && response.startsWith("http")) {
        const link = document.createElement("a");
        link.href = response;
        // optional: set filename — browsers often ignore cross-origin downloads for filename
        link.download = resumeName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        showToast("Download successful.", "success", 2000);
        return; // done
      }
      // ---------- TO HERE ----------

      // existing fallback for Blobs/ArrayBuffers (leave as-is)
      let blob = response;
      if (response instanceof ArrayBuffer) blob = new Blob([response]);
      //console.log(blob);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = resumeName || "resume.docx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
      showToast("Download successful.", "success", 2000);
    } catch (error) {
      showToast("Download unsuccessful.", "error", 2000);
      console.error(
        "Error triggering download:",
        error && error.message ? error.message : error
      );
    }
  };



  const handleAddNotes = async (jobPost, priority) => {
    try {
      const res = await addCandidateNotes({
        coll: "Note",
        postActions: ["updateSource"],
        payload: {
          addedBy: user?.data?.uiid,
          candidateId: resumeData?.uiid,
          note: notes,
          source: 2,
          ...(jobPost != null && { jobPostId: jobPost }),
          ...(priority != null && { priority })
        },
      });
      if (res?.data) {
        setNotesModal(false);
        showToast("Notes added successfully.", "success", 2000);
        setCandidateNotes("");
      }
    } catch (error) {
      showToast("Error adding notes.", "error", 2000)
      console.error("Error adding notes:", error);
    } finally {
    }
  };

  return (
    <div className="min-h-full flex bg-gray-100">
      <div className="flex-1 flex flex-col bg-white mx-[15%]">
        <div className="shadow-md !bg-[#fffcfa] rounded-lg p-3 mx-3 my-1">
          <PageHeader
            Section={
              <div className="flex items-center gap-4">
                <div className="flex flex-col items-start">
                  <div className="text-primary mb-0.5">
                    <PageTitle
                      title={`${sData?.candidate?.firstName} ${sData?.candidate?.lastName}`}
                      tag="h6"
                    />
                  </div>
                  <div className="text-gray-400 font-[500] text-xs">
                    <PageTitle title={currentApplicantJobTitle} tag="p" />
                  </div>
                </div>
                <StatusTags icon />
              </div>
            }
            RightSection={
              <div className="flex item-center gap-3">
                <SmartTooltip
                  description={"Call"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  <Button
                    color="black"
                    type="icon"
                    icon={"phone"}
                    variant="text"
                    size="sm"
                  />
                </SmartTooltip>
                <SmartTooltip
                  description={"Download"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  <Button
                    color="black"
                    type="icon"
                    disabled={
                      resumeLink || resumeData?.htmlResume ? false : true
                    }
                    onClick={getCandidateResume}
                    icon={"vertical_align_bottom"}
                    variant="text"
                    size="sm"
                  />
                </SmartTooltip>
                <Link
                  to="/resumeviewer"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-info-400 flex items-center gap-.5"
                >
                  <SmartTooltip
                    description={"Open New Tab"}
                    tooltipPosition={"bottom"}
                    noicon
                  >
                    <Button
                      color="black"
                      type="icon"
                      icon={"open_in_new"}
                      disabled={true}
                      variant="text"
                      size="sm"
                    />
                  </SmartTooltip>
                </Link>
                <SmartTooltip
                  description={"View Resume"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  <Button
                    color="black"
                    type="icon"
                    disabled={
                      resumeLink || resumeData?.htmlResume ? false : true
                    }
                    icon={"visibility"}
                    onClick={async () => {
                      setViewModal(true);
                      await viewResume(); // optional await if you want to ensure it completes before something else later
                    }}
                    variant="text"
                    size="sm"
                  />
                </SmartTooltip>
                <SmartTooltip
                  description={"Email"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  <Button
                    color="black"
                    type="icon"
                    icon={"mail"}
                    disabled={
                      resumeLink || resumeData?.htmlResume ? false : true
                    }
                    variant="text"
                    size="sm"
                    onClick={() => setEmailModal(true)}
                  />
                </SmartTooltip>
                <SmartTooltip
                  description={"Note"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  {(resumeLink || resumeData?.htmlResume) && (
                    <DualIcon
                      iconColor={"black"}
                      badgeIconColor="bg-black"
                      size="xs"
                      onClick={() => setNotesModal(true)}
                    />
                  )}
                </SmartTooltip>
                <SmartTooltip
                  description={"Submit Job"}
                  tooltipPosition={"bottom"}
                  noicon
                >
                  <DualIcon
                    size="xs"
                    icon="article"
                    badgeIcon="visibility"
                    iconColor="black"
                    dotPosition="bottom-right"
                    badgeIconColor="text-black"
                    onClick={() => setSubmitJobModal(true)}
                  />
                </SmartTooltip>
              </div>
            }
          />

          <div className="px-8 inner-section shadow-xl rounded-lg py-5 flex my-3">
            <div className="flex flex-1 w-full">
              <AdvSeparator gap="gap-6" className="gap-y-6 overflow-hidden">
                {Object.keys(contactHeader || {}).length === 0 ? (
                  <div>No contact info</div>
                ) : (
                  Object.keys(FixedContactHeader).map((key, index) => (
                    <InfoTextAdv
                      key={index}
                      title={key}
                      titleProps={{ className: "!text-black" }}
                      value={
                        <div className="w-full">
                          <div className="text-black font-medium">
                            {String(key).toLowerCase() === "email" ? (
                              <div className={"flex items-center gap-0.5 "}>
                                <h6 className="line-clamp-1">
                                  {FixedContactHeader[key]}
                                </h6>
                                <CopyToClipboard content={FixedContactHeader[key]} title={FixedContactHeader[key]} />
                              </div>
                            ) : (
                              <h6 className="line-clamp-1">
                                {FixedContactHeader[key]}
                              </h6>
                            )}
                          </div>
                        </div>
                      }
                    />
                  ))
                )}
              </AdvSeparator>
            </div>
          </div>
        </div>

        <div className="flex-1 flex flex-col overflow-hidden">
          <NewTab
            tabs={viewMenus}
            color="gray"
            variant="text"
            activeVariant="text"
          />
        </div>
      </div>

      <ApplicantEmailModal
        isOpen={emailModal}
        onClose={() => setEmailModal(false)}
      />
      <ApplicantNotesModal
        value={notes}
        onChange={(e) => {
          const val = e?.target?.value ?? e;
          setCandidateNotes(val);
        }}
        onClick={async (jobPost, priority) => {
          await handleAddNotes(jobPost, priority);
        }}
        isOpen={notesModal}
        onClose={() => {
          setNotesModal(false);
          setCandidateNotes("");
        }}
      />
      <ApplicantSubmitJobModal
        isOpen={submitJobModal}
        onClose={() => setSubmitJobModal(false)}
        applicant={resumeData}
      />
      <Modal
        width="max-w-6xl"
        title={resumeName || "Resume Details"}
        isOpen={viewModal}
        onClose={() => setViewModal(false)}
      >
        <DocumentViewerATS AwsResumeUrl={awsUrl || ""} />
      </Modal>
      <Backdrop isOpen={sData?.loading} zIndex={51}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default ResumeViewer;
